var _rect, _g, _g2, _rect2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "05-06 - Machine Management - Machine List - Created Success"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1755,
    y: -306,
    width: 1920,
    height: 1080
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-_05-01_-_Machine_Management_-_Machine_List"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M165 -306H-1755V774H165V-306Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M165 -306H-1755V774H165V-306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component Menu Viewer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17",
    d: "M165 -306H-1755V774H165V-306Z",
    fill: "#F5F6F8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path 9974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M144.5 747.457H-1734.5V-241.457H144.5V747.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M-1734 -240.914V746.914H144V-240.914H-1734ZM-1735 -242H145V748H-1735V-242Z",
    fill: "#D9DADE"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 4854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -20.5,
    y: -2.5,
    width: 144,
    height: 29,
    stroke: "#D9DADE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 12_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bt_log_inactive",
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.6
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bt_edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2133",
    opacity: 0.1,
    d: "M22.3182 0H2.68182C1.47683 0 0.5 0.976833 0.5 2.18182V21.8182C0.5 23.0232 1.47683 24 2.68182 24H22.3182C23.5232 24 24.5 23.0232 24.5 21.8182V2.18182C24.5 0.976833 23.5232 0 22.3182 0Z",
    fill: "#1424F9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 4852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.49846 7C3.16258 7.02954 2.84232 7.03291 2.53176 7.0903C1.952 7.19747 1.49756 7.83715 1.50431 8.45447C1.52414 10.3279 1.51191 12.2018 1.51106 14.0753C1.51106 14.6483 1.48828 15.2222 1.50811 15.7948C1.52541 16.2838 1.90939 16.7935 2.39168 16.9484C2.73093 17.0572 3.10604 17.0543 3.49044 17.1045L4.48245 17.0581H20.5234L21.5108 17.0834C21.8049 17.0585 22.1006 17.0598 22.385 17.0032C22.9623 16.888 23.3922 16.4462 23.4505 15.8437C23.5036 15.2926 23.4948 14.7348 23.4965 14.1799C23.5011 12.3305 23.5015 10.4811 23.4956 8.63169C23.4944 8.25067 23.4281 7.88483 23.1737 7.57006C22.9382 7.27849 22.6513 7.09663 22.2766 7.07553C22.0352 7.06203 21.793 7.073 21.5108 7.073L19.2082 7.06371L3.49846 7ZM14.4789 11.9098C14.4739 12.617 14.3283 13.2774 13.9696 13.8858C13.5346 14.6234 12.8945 15.0812 12.0603 15.2631C11.402 15.4061 10.7514 15.4171 10.1037 15.1766C9.24967 14.8593 8.71716 14.2508 8.37707 13.4246C8.12263 12.8061 8.08466 12.1617 8.1547 11.5259C8.28044 10.3849 8.76906 9.41146 9.84842 8.89752C10.9805 8.35869 12.132 8.42156 13.1894 9.11989C13.8152 9.5334 14.181 10.1668 14.3418 10.9001C14.4144 11.2309 14.435 11.5731 14.4789 11.9103V11.9098ZM3.83433 15.2399V8.6781H5.31454V8.9452C5.31454 10.5271 5.31454 12.109 5.31496 13.6913C5.31496 13.7795 5.3234 13.8677 5.32804 13.9559C5.34534 13.969 5.36222 13.982 5.37952 13.9951H7.92727V15.2403H3.83433V15.2399ZM20.9618 14.9774C20.5061 15.0715 20.0453 15.2002 19.5761 15.2551C19.0925 15.3116 18.5968 15.3412 18.1132 15.3015C17.4478 15.2471 16.8262 15.0336 16.2807 14.6129C15.6283 14.1095 15.2908 13.4234 15.1836 12.6466C15.0152 11.4284 15.287 10.317 16.2477 9.46758C16.7516 9.02242 17.3638 8.77389 18.025 8.67515C18.8579 8.55067 19.6862 8.60595 20.5014 8.82283C20.5829 8.84435 20.6567 8.89414 20.7352 8.9317C20.6344 9.31989 20.5386 9.68952 20.4365 10.0828C20.19 10.0284 19.9432 9.97054 19.6947 9.91907C19.0238 9.7794 18.3575 9.78278 17.7305 10.084C17.2246 10.3267 16.9212 10.7625 16.7933 11.2989C16.6241 12.0086 16.6824 12.7002 17.1119 13.3166C17.4499 13.801 17.9233 14.0757 18.52 14.0939C18.8052 14.1023 19.093 14.0774 19.3769 14.0445C19.4352 14.0377 19.5238 13.9297 19.5259 13.866C19.5398 13.4711 19.5326 13.0757 19.5326 12.6605H18.5314V11.4896H20.9618V14.9783V14.9774Z",
    fill: "#148BF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.4445 9.78621C10.9238 9.6917 10.3989 9.94613 10.1191 10.3917C9.80982 10.8841 9.7191 11.4259 9.68408 12.0044C9.72881 12.5589 9.81362 13.1078 10.1626 13.5926C10.5103 14.0758 11.1128 14.2922 11.6943 14.1159C12.2782 13.9386 12.5816 13.4985 12.7415 12.9606C12.9116 12.3884 12.9247 11.8036 12.8032 11.2057C12.6399 10.4035 12.215 9.92672 11.4445 9.78664V9.78621Z",
    fill: "#148BF9"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogInactive);
export default __webpack_public_path__ + "static/media/ic_log_inactive.3dd163f609f3b441d088ce534e554c8b.svg";
export { ForwardRef as ReactComponent };